import { render, staticRenderFns } from "./Bios.vue?vue&type=template&id=0884df85"
import script from "./Bios.vue?vue&type=script&lang=js"
export * from "./Bios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports